import { render } from "./LongBreak.vue?vue&type=template&id=9d51ec2c"
import script from "./LongBreak.vue?vue&type=script&lang=js"
export * from "./LongBreak.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__